export default __webpack_public_path__ + "static/convocatoria-0c579dac376ca860117325ea2b067a37.png";